import React from 'react';
import {style, classes} from './doppe-action-type-widget-inner-title.st.css';
import {DoppeHideableValue, doppeHideableValueIsHidden} from "../../client-server-common/types/doppe-hideable-value";
import {stringIsNullableOrWhiteSpace} from '@wix/devzai-utils-common';

export const DoppeActionTypeWidgetInnerTitle = React.memo(function DoppeActionTypeWidgetInnerTitle (props: DoppeActionTypeWidgetInnerTitle.Props) {
    const {
        children,

        className,
        ...htmlAttributes
    } = props;

    if (doppeHideableValueIsHidden(children) || stringIsNullableOrWhiteSpace(children)) {
        return null;
    }

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            {children}
        </div>
    );
});

export namespace DoppeActionTypeWidgetInnerTitle {

    export interface Props extends React.HTMLAttributes<any> {
        children: DoppeHideableValue<string>;
    }
}
